<style>
  #fotarda {
    width: 50px;
    vertical-align: middle !important;
    border-style: none !important;
    float: none !important;
}

.table thead th {
    font-size: 0.75rem;
    color: #000000 !important;

}

.table td, .table th {
    font-size: 0.95rem;
    padding-right: 0.5rem !important;
     padding-left: 0.5rem !important;
}

.table-with-watermark {
  position: relative;
  overflow: hidden; /* Asegura que el pseudo-elemento no se extienda fuera de la tabla */
}

.table-hover tr {
    color: #000000 !important;
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
}

.bigfont{

  font-size: 0.95rem !important;

}


.table-with-watermark::before {
  content: "";  /* Necesario para generar el pseudo-elemento */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;  /* Establece el ancho del pseudo-elemento igual al de su contenedor */
  height: 100%; /* Establece el alto del pseudo-elemento igual al de su contenedor */
  background-image: url('/img/brand/a&g.png'); /* Asegúrate que la ruta está correcta */
  background-position: center; /* Centra la imagen en el contenedor */
  background-repeat: no-repeat; /* No repetir la imagen */
  background-size: 300px !important;
  opacity: 0.04; /* Ajusta la transparencia */
  z-index: -1; /* Pone la imagen detrás del contenido */
}

.negativo {
  color: red;
}

.positivo {
  color: green;
}

.select-button-container {
  display: flex;
  align-items: center; /* Asegura que los elementos estén alineados verticalmente */
  justify-content: space-between; /* Separa el select y el botón */
  width: 100%; /* Opcional: asegura que el contenedor tome todo el ancho disponible */
}

.el-select {
  flex-grow: 1; /* Permite que el select crezca y tome el espacio disponible */
  margin-right: 20px; /* Añade un margen derecho para espacio entre select y botón */
}



</style>

<template>
  <div >

    <!-- Itera sobre los productos únicos para crear una tabla por producto -->
    <div v-for="(producto, index) in productosConEncabezados"  :key="index" class="mb-5">

      <b-card>

        <div class="select-button-container">
        <el-select v-model="jornadasSeleccionadas[producto.ID]" multiple placeholder="Seleccione Jornadas">
          <el-option
            v-for="jornada in datosFinalesPorProducto[producto.ID]"
            :key="jornada.jornada"
            :label="jornada.jornada"
            :value="jornada.jornada">
          </el-option>
        </el-select>
        <button class="btn btn-primary" @click="captureTableAsImage(`contenido-a-capturar-${index}`)">Descargar Tabla como Imagen</button>
      </div>


<br>
  <div class="table-responsive">
    <table class="table table-hover table-bordered table-with-watermark" :id="`contenido-a-capturar-${index}`">
    <thead>
      <tr>
      <th rowspan="2"   colspan="2" class="align-middle text-center">Manifestado 
        <br>
        ({{ producto.PRODUCTO }})
      </th>
      <th style="background-color:#BEDBE1" v-for="(bodega, index) in producto.bodegasUnicas" :key="`bodega-header-${index}-${bodega}`" colspan="2" class="align-middle text-center">{{ bodega }}</th>
      <th  style="background-color:#BEDBE1" class="align-middle text-center" colspan="2">Total Descargado</th>
      <th  style="background-color:#BEDBE1"  class="align-middle text-center">% Descargado</th>
      <th  class="align-middle text-center" style="background-color:rgba(255, 104, 0, 0.3);" v-for="almacen in producto.almacenUnicas" colspan="2" :key="almacen+'header'">{{ almacen }}</th>
      <th  class="align-middle text-center" style="background-color:rgba(255, 104, 0, 0.3);" colspan="2">Total Descargado</th>
      </tr>
      <tr>
      <th class="align-middle text-center bigfont" v-for="bodega in producto.bodegasUnicas" colspan="2" :key="bodega+'data'">
      {{ producto.items[0][bodega] || 'N/A' }} TM
      </th>
      <th class="align-middle text-center bigfont" colspan="2">{{ producto.totalDescargado }} TM</th>
      <th class="align-middle text-center bigfont"> 100%</th>
      <th class="align-middle text-center bigfont" v-for="almacen in producto.almacenUnicas" colspan="2" :key="almacen+'data'">
      {{ producto.itemss[0][almacen] || 'N/A' }} TM
      </th>
      <th class="align-middle text-center bigfont" colspan="2">{{ producto.totalDescargadoAlmacen }} TM</th>
      </tr>

      <tr>
          <th  :key="`bodega-header-${bodega}`"  colspan="1" class="align-middle text-center">Fecha</th>
          <th  :key="`bodega-header-${bodega}`"  colspan="1" class="align-middle text-center">Jornada</th>
            <template v-for="bodega in producto.bodegasUnicas">
              <th style="background-color:#BEDBE1" :key="`bodega-header-${bodega}`" rowspan="2" class="align-middle text-center">Peso </th>
              <th style="background-color:#BEDBE1" :key="`bodega-header-${bodega}`"  rowspan="2" class="align-middle text-center">Viajes </th>
            </template>
            <th style="background-color:#BEDBE1" :key="`bodega-header-${bodega}`" rowspan="2" class="align-middle text-center">Total Peso </th>
              <th style="background-color:#BEDBE1" :key="`bodega-header-${bodega}`"  rowspan="2" class="align-middle text-center">Total Viajes </th>
               <th style="background-color:#BEDBE1" rowspan="2" class="align-middle text-center">% </th>
            <template v-for="almacen in producto.almacenUnicas">
                <th style="background-color:rgba(255, 104, 0, 0.3);" :key="`almacen-peso-${almacen}`" rowspan="2" class="align-middle text-center">Peso</th>
                <th style="background-color:rgba(255, 104, 0, 0.3);" :key="`almacen-viajes-${almacen}`" rowspan="2"  class="align-middle text-center">Viajes</th>
            </template>
            <th style="background-color:rgba(255, 104, 0, 0.3);" :key="`bodega-header-${bodega}`" rowspan="2" class="align-middle text-center">Total Peso </th>
            <th style="background-color:rgba(255, 104, 0, 0.3);" :key="`bodega-header-${bodega}`"  rowspan="2" class="align-middle text-center">Total Viajes </th>  
                  </tr>
              <tr>
              </tr>
    </thead>
    <tbody>
<template v-for="(jornadas, indexJornada) in datosFinalesPorProducto[producto.ID] && jornadasSeleccionadas[producto.ID] ? datosFinalesPorProducto[producto.ID].filter(j => jornadasSeleccionadas[producto.ID].includes(j.jornada) || jornadasSeleccionadas[producto.ID].length === 0) : []">
  <tr :key="`jornada-row-${indexJornada}`">       
            <td class="align-middle text-center">{{ calcularFechasYRangos(DataCompleta[0].FECHA_INGRESO_BALANZA, indexJornada).fecha }}</td>
            <td class="align-middle text-center">{{ calcularFechasYRangos(DataCompleta[0].FECHA_INGRESO_BALANZA, indexJornada).rango }}</td>
                <template v-for="bodegaData in jornadas.bodegas">
                    <td :key="`peso-${bodegaData.bodega}`" class="align-middle text-center">{{ bodegaData.pesoNeto }} TM</td>
                    <td :key="`viajes-${bodegaData.bodega}`" class="align-middle text-center">{{ bodegaData.viajes }}</td>
                </template>
                <td class="align-middle text-center"><b>{{ calculateTotalPeso(jornadas.bodegas) }} TM</b></td>
                <td class="align-middle text-center"><b>{{ calculateTotalViajes(jornadas.bodegas) }}</b></td>
                <td class="align-middle text-center"><b>{{ calculatePercentageDescargado(jornadas.bodegas, producto.totalDescargado) }}%</b></td>
                <template v-for="almacen in producto.almacenUnicas">
                <td :key="`peso-${almacen}`" class="align-middle text-center">
                  {{ getPesoNetoAlmacen(jornadas, almacen) }}
                </td>
                <td :key="`viajes-${almacen}`" class="align-middle text-center">
                  {{ getViajesAlmacen(jornadas, almacen) }}
                </td>
              </template>
                <td class="align-middle text-center"><b>{{ calculateTotalPesoAlmacen(jornadas.almacenes) }} TM</b></td>
                <td class="align-middle text-center"><b>{{ calculateTotalViajesAlmacen(jornadas.almacenes) }}</b></td>
            </tr>
        </template>

        <tr>
    <td class="align-middle text-center" colspan="2"><strong>Descargado</strong></td>
    <template v-for="bodega in producto.bodegasUnicas">
      <td :key="`total-peso-${bodega}`" class="align-middle text-center">
        <b>{{ calculateFilteredBodegaPeso(producto, bodega) }}</b>
      </td>
      <td :key="`total-viajes-${bodega}`" class="align-middle text-center">
        <b>{{ calculateFilteredBodegaViajes(producto, bodega) }}</b>
      </td>
    </template>
    <!-- Suma total de todas las bodegas mostrada aquí -->
    <td class="align-middle text-center">
      <b>{{ calculateTotalFilteredPeso(producto) }}</b>
    </td>
    <td class="align-middle text-center">
      <b>{{ calculateTotalFilteredViajes(producto) }}</b>
    </td>
    <td class="align-middle text-center">
      <b>{{ calculateFilteredPercentageDescargado(producto) }}</b>
    </td>
    <template v-for="almacen in producto.almacenUnicas">
      <td :key="`total-peso-almacen-${almacen}`" class="align-middle text-center">
        <b>{{ calculateFilteredAlmacenPeso(producto, almacen) }}</b>
      </td>
      <td :key="`total-viajes-almacen-${almacen}`" class="align-middle text-center">
        <b>{{ calculateFilteredAlmacenViajes(producto, almacen) }}</b>
      </td>
    </template>
    <td class="align-middle text-center">
      <b>{{ calculateTotalFilteredAlmacenPeso(producto) }}</b>
    </td>
    <td class="align-middle text-center">
      <b>{{ calculateTotalFilteredAlmacenViajes(producto) }}</b>
    </td>
  </tr>

        <!-- <tr>
    <td class="align-middle text-center" colspan="2"><strong>Descargado</strong></td>
    <template v-for="bodega in producto.bodegasUnicas">
        <td :key="`total-peso-${bodega}`" class="align-middle text-center">
          <b> {{ datosTotalesPorProducto[producto.ID].bodegas.find(b => b.bodega === bodega).pesoNeto }} TM</b> 
        </td>
        <td :key="`total-viajes-${bodega}`" class="align-middle text-center">
          <b> {{ datosTotalesPorProducto[producto.ID].bodegas.find(b => b.bodega === bodega).viajes }}</b> 
        </td>
    </template>
    <td class="align-middle text-center"><b>{{ datosTotalesPorProducto[producto.ID].totalPesoNeto }} TM</b></td>
    <td class="align-middle text-center"><b>{{ datosTotalesPorProducto[producto.ID].totalViajes }}</b></td>
    <td class="align-middle text-center"><b>{{ calculateTotalPercentageDescargado(datosTotalesPorProducto[producto.ID].totalPesoNeto, producto.totalDescargado) }}%</b></td>
    <template v-for="almacen in producto.almacenUnicas">
        <td :key="`total-peso-almacen-${almacen}`" class="align-middle text-center">
          <b> {{ datosConsolidadosPorProductoCompleto[producto.ID].almacenes.find(a => a.almacen === almacen).pesoNetoAlmacen }} TM</b>
        </td>
        <td :key="`total-viajes-almacen-${almacen}`" class="align-middle text-center">
          <b>  {{ datosConsolidadosPorProductoCompleto[producto.ID].almacenes.find(a => a.almacen === almacen).viajes }}</b>
        </td>
    </template>
    <td class="align-middle text-center"><b>{{ datosConsolidadosPorProductoCompleto[producto.ID].totalPesoNetoAlmacen }} TM</b></td>
    <td class="align-middle text-center"><b>{{ datosConsolidadosPorProductoCompleto[producto.ID].totalViajesAlmacen }}</b></td>
</tr> -->

<tr>
  <td class="align-middle text-center" colspan="2"><strong>Saldos</strong></td>
  <template v-for="bodega in producto.bodegasUnicas">
    <td :class="{'negativo': calculateFilteredBodegaSaldo(producto, bodega) < 0, 'positivo': calculateFilteredBodegaSaldo(producto, bodega) >= 0}" 
      :key="`saldo-peso-${bodega}`" class="align-middle text-center">
      <b>{{ calculateFilteredBodegaSaldo(producto, bodega) }} TM</b>
    </td>
    <td :key="`saldo-viajes-${bodega}`" class="align-middle text-center">—</td>
  </template>
  <td class="align-middle text-center" :class="{'negativo': calculateTotalSaldoBodegas(producto) < 0, 'positivo': calculateTotalSaldoBodegas(producto) >= 0}">
    <b>{{ calculateTotalSaldoBodegas(producto).toFixed(3) }} TM</b>
  </td>
  <td class="align-middle text-center">—</td>
  <td class="align-middle text-center">—</td>
  <template v-for="almacen in producto.almacenUnicas">
    <td :class="{'negativo': calculateFilteredAlmacenSaldo(producto, almacen) < 0, 'positivo': calculateFilteredAlmacenSaldo(producto, almacen) >= 0}" 
      :key="`total-peso-almacen-${almacen}`" class="align-middle text-center">
      <b>{{ calculateFilteredAlmacenSaldo(producto, almacen) }} TM</b>
    </td>
    <td :key="`saldo-viajes-almacen-${almacen}`" class="align-middle text-center">—</td>
  </template>
  <td class="align-middle text-center" :class="{'negativo': calculateTotalSaldoAlmacenes(producto) < 0, 'positivo': calculateTotalSaldoAlmacenes(producto) >= 0}">
    <b>{{ calculateTotalSaldoAlmacenes(producto).toFixed(3) }} TM</b>
  </td>
  <td class="align-middle text-center">—</td>
</tr>

 




<!-- 
<tr>
    <td class="align-middle text-center" colspan="2"><strong>Saldos</strong></td>
    <template v-for="bodega in producto.bodegasUnicas">
      <td :class="{'negativo': (datosTotalesPorProducto[producto.ID].bodegas.find(b => b.bodega === bodega).pesoNeto - (producto.items[0][bodega] || 0)) < 0, 'positivo': (datosTotalesPorProducto[producto.ID].bodegas.find(b => b.bodega === bodega).pesoNeto - (producto.items[0][bodega] || 0)) >= 0}" :key="`saldo-peso-${bodega}`" class="align-middle text-center">
        <b>{{ (datosTotalesPorProducto[producto.ID].bodegas.find(b => b.bodega === bodega).pesoNeto - (producto.items[0][bodega] || 0)).toFixed(3) }} TM</b>
      </td>
      <td :key="`saldo-viajes-${bodega}`" class="align-middle text-center">—</td>
    </template>
    <td :class="{'negativo': (datosTotalesPorProducto[producto.ID].totalPesoNeto - producto.totalDescargado || 0) < 0, 'positivo': (datosTotalesPorProducto[producto.ID].totalPesoNeto - producto.totalDescargado || 0) >= 0}" class="align-middle text-center">
        <b>{{ (datosTotalesPorProducto[producto.ID].totalPesoNeto - producto.totalDescargado || 0).toFixed(3) }} TM</b>
    </td>
    <td class="align-middle text-center">—</td>
    <td class="align-middle text-center">—</td>
    <template v-for="almacen in producto.almacenUnicas">
      <td :class="{'negativo': (datosConsolidadosPorProductoCompleto[producto.ID].almacenes.find(a => a.almacen === almacen).pesoNetoAlmacen - (producto.itemss[0][almacen] || 0)) < 0, 'positivo': (datosConsolidadosPorProductoCompleto[producto.ID].almacenes.find(a => a.almacen === almacen).pesoNetoAlmacen - (producto.itemss[0][almacen] || 0)) >= 0}" :key="`total-peso-almacen-${almacen}`" class="align-middle text-center">
        <b>{{ (datosConsolidadosPorProductoCompleto[producto.ID].almacenes.find(a => a.almacen === almacen).pesoNetoAlmacen - (producto.itemss[0][almacen] || 0)).toFixed(3) }} TM</b>
      </td>
      <td :key="`saldo-viajes-almacen-${almacen}`" class="align-middle text-center">—</td>
    </template>
    <td :class="{'negativo': (datosConsolidadosPorProductoCompleto[producto.ID].totalPesoNetoAlmacen - producto.totalDescargadoAlmacen || 0) < 0, 'positivo': (datosConsolidadosPorProductoCompleto[producto.ID].totalPesoNetoAlmacen - producto.totalDescargadoAlmacen || 0) >= 0}" class="align-middle text-center">
        <b>{{ (datosConsolidadosPorProductoCompleto[producto.ID].totalPesoNetoAlmacen - producto.totalDescargadoAlmacen || 0).toFixed(3) }} TM</b>
    </td>
    <td class="align-middle text-center">—</td>
</tr> -->

    </tbody>
</table>
</div>



      </b-card>
    </div>
  </div>
</template>


<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
  import { Pagination } from 'element-ui';
  import { Select, Option } from 'element-ui';
  import html2canvas from 'html2canvas';
  import moment from 'moment'

  export default {

    props: {
    listaDatosData: {
      type: Array,  
      default: () => [],
    },
    listaDatos: {
      type: Array,
      default: () => [],
    },
    listaDatosProducto: {
      type: Array,
      default: () => [],
    },
    listaConsignave: {
      type: Array,
      default: () => [],
    },
    listaClientesNave: {
      type: Array,
      default: () => [],
    },
    DataCompleta: {
      type: Array,
      default: () => [],
    },
    listaDatosDistribucion: {
      type: Array,
      default: () => [],
    },
    listaDatosAlmacenDistribucion: {
      type: Array,
      default: () => [],
    },
    listaJornada: {
      type: Array,
      default: () => [],
    },
    BuquesFechas: {
      type: Array,
      default: () => [],
    },
    listaSilos: {
      type: Array,
      default: () => [],
    },
  },
    name: 'page-visits-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      'el-pagination': Pagination,
      'el-select': Select,
      'el-option': Option

    },
    data() {
      return {
        camposTabla: [
        { key: 'jornada', label: 'Jornada' },
        { key: 'bodegas', label: 'Peso Neto Salida (TM)' },
        { key: 'viajes', label: 'Viajes' },

      ],
          jornadasSeleccionadas: {},  // Almacena las jornadas seleccionadas para cada producto como arrays
          bodega: '', // Inicializa con un valor por defecto adecuado

      }
    },


      mounted() {
  this.fetchData().then(() => {
    this.inicializarJornadasSeleccionadas();
  });
},

watch: {
  // Observa los datos necesarios y llama a inicializar cuando estén listos
  'productosConEncabezados': function (newVal, oldVal) {
    if (newVal.length > 0 && this.datosFinalesPorProducto) {
      this.inicializarJornadasSeleccionadas();
    }
  },
  'datosFinalesPorProducto': function (newVal, oldVal) {
    if (newVal && this.productosConEncabezados.length > 0) {
      this.inicializarJornadasSeleccionadas();
    }
  }
},


     computed:{


      SilosUnicos() {
          // Esto asume que DataCompleta es tu lista de datos original
          const silos = this.listaSilos.map(row => row.ID_PRODUCTO);
          // Filtra los duplicados
          return Array.from(new Set(silos))
        },

        SilosCompleta() {

                if (!this.listaSilos || !this.listaJornada || !this.listaDatosAlmacenDistribucion ) {
                return []; // Retorna un arreglo vacío si alguna dependencia no está disponible aún
                }

                return this.listaSilos.map(item => {
                const jornadaItem = this.listaJornada.find(j => j.ID === item.JORNADA);
                const bodegaEncontrado = this.listaDatosDistribucion.find (b => b.ID === item.ID_DIST_PRODUCTOS )
                return  {
                PESO_NETO_PUERTO: this.convertir(item.PESO_NETO),
                BODEGA: bodegaEncontrado ? bodegaEncontrado.BODEGA : "Bodega no encontrada",
                JORNADA: jornadaItem ? jornadaItem.JORNADA : item.JORNADA,
                ID_PRODUCTO: item.ID_PRODUCTO,

                };

                })

                },

                datosConsolidadosPorProductoCompleto() {
    let resultadosPorProducto = {};

    // Iteramos sobre cada producto único.
    this.productosUnicos.forEach(producto => {
        let bodegasAcumuladas = {};
        let almacenesAcumulados = {};
        let totalPesoNetoPorProducto = 0;  
        let totalViajesPorProducto = 0;    
        let totalPesoNetoAlmacenPorProducto = 0;  
        let totalViajesAlmacenPorProducto = 0;    

        // Obtener todas las bodegas y almacenes únicos para este producto
        const almacenesUnicos = [...new Set(this.listaDatosAlmacenDistribucion.filter(a => a.ID_PRODUCTO === producto.ID).map(a => a.ALMACEN))];

        // Inicializar todos los almacenes con valores por defecto
        almacenesUnicos.forEach(almacen => {
            almacenesAcumulados[almacen] = { pesoNetoAlmacen: 0, viajes: 0 };
        });

        // Filtramos los datos por el producto actual.
        this.DataCompleta.filter(dato => dato.ID_PRODUCTO === producto.ID).forEach(dato => {
            const bodegaId = dato.BODEGA || "Sin Bodega";
            const almacenId = dato.DESTINO || "Sin Almacen";
            const pesoNeto = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;
            const pesoNetoAlmacen = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;
            const guia = dato.GUIA || 0;

            // Inicializar bodega si aún no existe en el acumulado y si bodegaId y guia son válidos
            if (bodegaId !== "Sin Bodega" && bodegaId !== 0 && guia !== 0) {
                if (!bodegasAcumuladas[bodegaId]) {
                    bodegasAcumuladas[bodegaId] = { pesoNeto: 0, viajes: 0 };
                }
                // Sumar pesos y contar viajes para la bodega
                bodegasAcumuladas[bodegaId].pesoNeto += pesoNeto;
                bodegasAcumuladas[bodegaId].viajes += 1;

                // Acumular totales para el producto
                totalPesoNetoPorProducto += pesoNeto;
                totalViajesPorProducto += 1;
            }

            // Procesar almacenes si almacenId es válido y guia no es cero
            if (almacenId !== "Sin Almacen" && almacenesAcumulados[almacenId] && guia !== 0) {
                almacenesAcumulados[almacenId].pesoNetoAlmacen += pesoNetoAlmacen;
                almacenesAcumulados[almacenId].viajes += 1;

                totalPesoNetoAlmacenPorProducto += pesoNetoAlmacen;
                totalViajesAlmacenPorProducto += 1;
            }
        });

        // Convertir el objeto de bodegas acumuladas y almacenes en arrays y agregar totales globales
        let bodegasArray = Object.entries(bodegasAcumuladas).map(([bodegaKey, bodegaData]) => ({
            bodega: bodegaKey,
            pesoNeto: bodegaData.pesoNeto.toFixed(3),
            viajes: bodegaData.viajes
        }));
        let almacenesArray = Object.entries(almacenesAcumulados).map(([almacenKey, almacenData]) => ({
            almacen: almacenKey,
            pesoNetoAlmacen: almacenData.pesoNetoAlmacen.toFixed(3),
            viajes: almacenData.viajes
        }));

        // Asignar los datos al producto en el objeto de resultados
        resultadosPorProducto[producto.ID] = {
            bodegas: bodegasArray,
            almacenes: almacenesArray,
            totalPesoNeto: totalPesoNetoPorProducto.toFixed(3),
            totalViajes: totalViajesPorProducto,
            totalPesoNetoAlmacen: totalPesoNetoAlmacenPorProducto.toFixed(3),
            totalViajesAlmacen: totalViajesAlmacenPorProducto
        };
    });

    return resultadosPorProducto;
},



  datosConsolidadosPorProductoCompletoSilos() {
    let resultadosPorProducto = {};

    // Iteramos sobre cada producto único.
    this.productosUnicos.forEach(producto => {
        let bodegasAcumuladas = {};
        // let almacenesAcumulados = {};
        let totalPesoNetoPorProducto = 0;  // Suma total de peso neto por producto
        let totalViajesPorProducto = 'SILOS';    // Suma total de viajes por producto
        // let totalPesoNetoAlmacenPorProducto = 0;  // Suma total de peso neto en almacenes por producto
        // let totalViajesAlmacenPorProducto = 0;    // Suma total de viajes a almacenes por producto

        // Filtramos los datos por el producto actual.
        this.SilosCompleta.filter(dato => dato.ID_PRODUCTO === producto.ID).forEach(dato => {
            const bodegaId = dato.BODEGA || "Sin Bodega";  // Usamos "Sin Bodega" como clave predeterminada si no está especificado
            // const almacenId = dato.DESTINO || "Sin Almacen";  // Usamos "Sin Almacen" como clave predeterminada si no está especificado
            const pesoNeto = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;
            // const pesoNetoAlmacen = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;  // Asumiendo mismo campo para simplificar

            // Inicializar bodega si aún no existe en el acumulado
            if (!bodegasAcumuladas[bodegaId]) {
                bodegasAcumuladas[bodegaId] = { pesoNeto: 0, viajes: 0 };
            }

            // Inicializar almacen si aún no existe en el acumulado
            // if (!almacenesAcumulados[almacenId]) {
            //     almacenesAcumulados[almacenId] = { pesoNetoAlmacen: 0, viajes: 0 };
            // }

            // Sumar pesos y contar viajes para la bodega
            bodegasAcumuladas[bodegaId].pesoNeto += pesoNeto;
            bodegasAcumuladas[bodegaId].viajes += 1;

            // Sumar pesos y contar viajes para el almacen
            // almacenesAcumulados[almacenId].pesoNetoAlmacen += pesoNetoAlmacen;
            // almacenesAcumulados[almacenId].viajes += 1;

            // Acumular totales para el producto
            totalPesoNetoPorProducto += pesoNeto;
            totalViajesPorProducto =  'SILOS';
            // totalPesoNetoAlmacenPorProducto += pesoNetoAlmacen;
            // totalViajesAlmacenPorProducto += 1;
        });

        // Convertir el objeto de bodegas acumuladas y almacenes en arrays y agregar totales globales
        let bodegasArray = Object.entries(bodegasAcumuladas).map(([bodegaKey, bodegaData]) => ({
            bodega: bodegaKey,
            pesoNeto: bodegaData.pesoNeto.toFixed(3),
            viajes: 'SILOS'
        }));
        // let almacenesArray = Object.entries(almacenesAcumulados).map(([almacenKey, almacenData]) => ({
        //     almacen: almacenKey,
        //     pesoNetoAlmacen: almacenData.pesoNetoAlmacen.toFixed(3),
        //     viajes: almacenData.viajes
        // }));

        // Asignar los datos al producto en el objeto de resultados
        resultadosPorProducto[producto.ID] = {
            bodegas: bodegasArray,
            // almacenes: almacenesArray,
            totalPesoNeto: totalPesoNetoPorProducto.toFixed(3),
            totalViajes: 'SILOS',
            // totalPesoNetoAlmacen: totalPesoNetoAlmacenPorProducto.toFixed(3),
            // totalViajesAlmacen: totalViajesAlmacenPorProducto
        };
    });

    return resultadosPorProducto;
},

datosConsolidadosPorProducto() {
    let resultadosPorProducto = {};

    // Iteramos sobre cada producto único.
    this.productosUnicos.forEach(producto => {
        let agrupadosPorJornada = {};

        // Inicializamos todas las jornadas basadas en listaJornada
        this.listaJornada.forEach(jornada => {
            agrupadosPorJornada[jornada.JORNADA] = {
                totalPeso: 0, 
                totalPesoAlmacen: 0, 
                bodegas: {},
                almacenes: {}
            };

            // Inicializamos todas las bodegas y almacenes para cada jornada
            this.listaDatosDistribucion.filter(d => d.ID_PRODUCTO === producto.ID).forEach(d => {
                agrupadosPorJornada[jornada.JORNADA].bodegas[d.BODEGA] = {
                    bodega: d.BODEGA, 
                    pesoNeto: 0, 
                    viajes: 0, 
                    totalPesoNeto: 0
                };
            });
            this.listaDatosAlmacenDistribucion.filter(d => d.ID_PRODUCTO === producto.ID).forEach(d => {
                if (d.ALMACEN !== "Sin Almacen") { // Solo inicializamos los almacenes que son encontrados
                    agrupadosPorJornada[jornada.JORNADA].almacenes[d.ALMACEN] = {
                        almacen: d.ALMACEN, 
                        pesoNetoAlmacen: 0, 
                        viajes: 0
                    };
                }
            });
        });

        // Procesamos los datos de DataCompleta
        this.DataCompleta.filter(dato => dato.ID_PRODUCTO === producto.ID).forEach(dato => {
            const jornadaKey = dato.JORNADA;
            const bodegaId = dato.BODEGA || "Sin Bodega";
            const almacenId = dato.DESTINO || "Sin Almacen";
            const pesoNeto = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;
            const pesoNetoAlmacen = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;
            const guia = dato.GUIA || 0;

            // Aseguramos que las estructuras están inicializadas
            if (!agrupadosPorJornada[jornadaKey].bodegas[bodegaId]) {
                agrupadosPorJornada[jornadaKey].bodegas[bodegaId] = {
                    bodega: bodegaId, 
                    pesoNeto: 0, 
                    viajes: 0, 
                    totalPesoNeto: 0
                };
            }
            if (almacenId !== "Sin Almacen" && agrupadosPorJornada[jornadaKey].almacenes[almacenId]) {
                agrupadosPorJornada[jornadaKey].almacenes[almacenId].pesoNetoAlmacen += pesoNetoAlmacen;
                agrupadosPorJornada[jornadaKey].almacenes[almacenId].viajes += 1;
            }

            // Actualización de datos por jornada
            agrupadosPorJornada[jornadaKey].bodegas[bodegaId].pesoNeto += pesoNeto;
            agrupadosPorJornada[jornadaKey].bodegas[bodegaId].totalPesoNeto += pesoNeto;
            if (guia !== 0) {
                agrupadosPorJornada[jornadaKey].bodegas[bodegaId].viajes += 1;
            }
        });

        // Formateo final de los resultados por producto
        let jornadas = Object.entries(agrupadosPorJornada).map(([jornadaKey, jornadaData]) => ({
            jornada: jornadaKey,
            bodegas: Object.values(jornadaData.bodegas).map(b => ({
                ...b, 
                pesoNeto: b.pesoNeto.toFixed(3), 
                totalPesoNeto: b.totalPesoNeto.toFixed(3)
            })),
            almacenes: Object.values(jornadaData.almacenes).map(a => ({
                ...a, 
                pesoNetoAlmacen: a.pesoNetoAlmacen.toFixed(3)
            })),
            totalPeso: jornadaData.totalPeso.toFixed(3),
            totalPesoAlmacen: jornadaData.totalPesoAlmacen.toFixed(3)
        }));

        resultadosPorProducto[producto.ID] = jornadas;
    });

    return resultadosPorProducto;
},

datosConsolidadosPorProductoSilos() {
    let resultadosPorProducto = {};

    // Iteramos sobre cada producto único.
    this.productosUnicos.forEach(producto => {
        let agrupadosPorJornada = {};

        // Obtener todas las bodegas y almacenes únicos para este producto
        const bodegasUnicas = [...new Set(this.listaDatosDistribucion.filter(d => d.ID_PRODUCTO === producto.ID).map(d => d.BODEGA))];
        const almacenesUnicos = [...new Set(this.listaDatosAlmacenDistribucion.filter(d => d.ID_PRODUCTO === producto.ID).map(d => d.DESTINO))];

        // Datos por producto en SilosCompleta
        this.SilosCompleta.filter(dato => dato.ID_PRODUCTO === producto.ID).forEach(dato => {
            const jornadaId = dato.JORNADA;
            const bodegaId = dato.BODEGA || "Sin Bodega";  // Default key if no bodega specified
            const pesoNetoSilos = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;

            // Inicializar jornada si aún no existe
            if (!agrupadosPorJornada[jornadaId]) {
                agrupadosPorJornada[jornadaId] = {
                    totalPeso: 0,
                    totalPesoAlmacen: 0,
                    bodegas: {},
                    almacenes: {}
                };
                // Initialize all bodegas except 'SILOS'
                bodegasUnicas.forEach(bodega => {
                    if (bodega !== 'SILOS') {
                        agrupadosPorJornada[jornadaId].bodegas[bodega] = { pesoNeto: 0, viajes: 0, totalPesoNeto: 0 };
                    }
                });
                // Initialize all almacenes
                almacenesUnicos.forEach(almacen => {
                    agrupadosPorJornada[jornadaId].almacenes[almacen] = { pesoNetoAlmacen: 0, viajes: 0 };
                });
            }

            // Sumar pesos y contar viajes para bodegas except 'SILOS'
            if (bodegasUnicas.includes(bodegaId) && bodegaId !== 'SILOS') {
                agrupadosPorJornada[jornadaId].bodegas[bodegaId].pesoNeto += pesoNetoSilos;
                agrupadosPorJornada[jornadaId].bodegas[bodegaId].viajes += 1;
                agrupadosPorJornada[jornadaId].bodegas[bodegaId].totalPesoNeto += pesoNetoSilos;
            }
        });

        // Datos por producto en DataCompleta
        this.DataCompleta.filter(dato => dato.ID_PRODUCTO === producto.ID).forEach(dato => {
            const jornadaId = dato.JORNADA;
            const almacenId = dato.DESTINO || "Sin Almacen"; // Default key if no DESTINO specified
            const pesoNetoAlmacen = this.convertToNumber(dato.PESO_NETO_PUERTO) || 0;

            if (!agrupadosPorJornada[jornadaId]) {
                agrupadosPorJornada[jornadaId] = {
                    totalPeso: 0,
                    totalPesoAlmacen: 0,
                    bodegas: {},
                    almacenes: {}
                };
                // Initialize bodegas and almacenes again if needed
                bodegasUnicas.forEach(bodega => {
                    if (bodega !== 'SILOS') {
                        agrupadosPorJornada[jornadaId].bodegas[bodega] = { pesoNeto: 0, viajes: 0, totalPesoNeto: 0 };
                    }
                });
                almacenesUnicos.forEach(almacen => {
                    agrupadosPorJornada[jornadaId].almacenes[almacen] = { pesoNetoAlmacen: 0, viajes: 0 };
                });
            }

            // Sumar pesos y contar viajes para almacenes
            if (almacenesUnicos.includes(almacenId)) {
                agrupadosPorJornada[jornadaId].almacenes[almacenId].pesoNetoAlmacen += pesoNetoAlmacen;
                agrupadosPorJornada[jornadaId].almacenes[almacenId].viajes += 1;
            }

            // Actualizar totales para la jornada
            agrupadosPorJornada[jornadaId].totalPeso += pesoNetoAlmacen; 
            agrupadosPorJornada[jornadaId].totalPesoAlmacen += pesoNetoAlmacen;
        });

        // Convertimos los datos agrupados en un formato final para este producto
        let jornadas = Object.entries(agrupadosPorJornada).map(([jornadaKey, jornadaData]) => {
            let bodegasArray = Object.entries(jornadaData.bodegas).map(([bodegaKey, bodegaData]) => ({
                bodega: bodegaKey,
                pesoNeto: bodegaData.pesoNeto.toFixed(3),
                viajes: bodegaData.viajes,
                totalPesoNeto: bodegaData.totalPesoNeto.toFixed(3)
            }));
            let almacenesArray = Object.entries(jornadaData.almacenes).map(([almacenKey, almacenData]) => ({
                almacen: almacenKey,
                pesoNetoAlmacen: almacenData.pesoNetoAlmacen.toFixed(3),
                viajes: almacenData.viajes
            }));

            return {
                jornada: jornadaKey,
                bodegas: bodegasArray,
                almacenes: almacenesArray,
                totalPeso: jornadaData.totalPeso.toFixed(3),
                totalPesoAlmacen: jornadaData.totalPesoAlmacen.toFixed(3)
            };
        });

        // Asignamos los datos finales por jornada al objeto de resultados por producto
        resultadosPorProducto[producto.ID] = jornadas;
    });

    return resultadosPorProducto;
},


datosFinalesPorProducto() {
    const datosSilos = this.datosConsolidadosPorProductoSilos;
    const datosNormales = this.datosConsolidadosPorProducto;
    let resultadosFinales = {};

    // Itera sobre cada producto usando los IDs de productos únicos
    this.productosUnicos.forEach(producto => {
        const id = producto.ID;
        let datosUsados;
        let usarDatosSilos = false;  // Bandera para determinar si se usan los datos de Silos

        // Chequea si los datos correspondientes en datosSilos están vacíos
        if (!datosSilos[id] || datosSilos[id].length === 0) {
            datosUsados = datosNormales[id]; // Usa datos normales si los datos de Silos están vacíos
        } else {
            // Comprueba si todos los viajes de bodegas para cada jornada son 0
            let allViajesZero = true;
            for (let jornada of datosSilos[id]) {
                for (let bodega of jornada.bodegas) {
                    if (bodega.viajes > 0) {
                        allViajesZero = false;
                        break;
                    }
                }
                if (!allViajesZero) break;
            }

            // Determina qué datos usar
            usarDatosSilos = !allViajesZero;
            datosUsados = usarDatosSilos ? datosSilos[id] : datosNormales[id];
        }

        // Modifica los viajes si son mayores o iguales a 1, solo para bodegas, que muestren 'SILOS'
        // Esto solo se aplica si se están usando datos de Silos
        if (datosUsados && usarDatosSilos) {
            datosUsados = datosUsados.map(jornada => {
                let bodegas = jornada.bodegas.map(bodega => {
                    return {
                        ...bodega,
                        viajes: bodega.viajes >= 1 ? "SILOS" : bodega.viajes
                    };
                });
                return {
                    ...jornada,
                    bodegas: bodegas,
                    almacenes: jornada.almacenes
                };
            });
        }

        // Asigna los datos finales modificados
        resultadosFinales[id] = datosUsados;
    });

    return resultadosFinales;
},

  

        datosTotalesPorProducto() {
    const datosNormales = this.datosConsolidadosPorProductoCompleto;
    const datosSilos = this.datosConsolidadosPorProductoCompletoSilos;
    let resultadosFinales = {};

    this.productosUnicos.forEach(producto => {
      const datosSilosProducto = datosSilos[producto.ID];
      const datosNormalesProducto = datosNormales[producto.ID];

      // Verifica si los datos de bodegas en Silos están vacíos
      if (!datosSilosProducto || 
          !datosSilosProducto.bodegas ||
          datosSilosProducto.bodegas.length === 0 ||
          datosSilosProducto.bodegas.every(bodega => bodega.pesoNeto === "0.000")) {
        // Usa datos normales si los datos de Silos están vacíos o no tienen peso neto
        resultadosFinales[producto.ID] = datosNormalesProducto;
      } else {
        // Usa datos de Silos si están disponibles y tienen información útil
        resultadosFinales[producto.ID] = datosSilosProducto;
      }
    });

    return resultadosFinales;
  },




  productosConEncabezados() {
  return this.productosUnicos.map(producto => {
    const distribuciones = this.listaDatosDistribucion.filter(d => d.ID_PRODUCTO === producto.ID);
    const almacenes = this.listaDatosAlmacenDistribucion.filter(d => d.ID_PRODUCTO === producto.ID);
    // Filtra "SILOS" al construir bodegasUnicas
    const bodegasUnicas = [...new Set(distribuciones.map(d => d.BODEGA).filter(bodega => bodega !== "SILOS"))];
    const almacenUnicas = [...new Set(almacenes.map(d => d.ALMACEN))];

    const encabezados = bodegasUnicas.map(bodega => ({ key: bodega, label: bodega }));
    const encabezatres = almacenUnicas.map(almacen => ({ key: almacen, label: almacen }));
    // Agrega el encabezado para el Total Descargado
    encabezados.push({ key: 'totalDescargado', label: 'Total Descargado' });
    encabezatres.push({ key: 'totalDescargadoAlmacen', label: 'Total Descargado' });

    let filaDatos = {};
    distribuciones.forEach(({ BODEGA, CANTIDAD }) => {
      if (BODEGA !== "SILOS") {  // Asegúrate de no incluir "SILOS" en los datos finales
        filaDatos[BODEGA] = this.convertToNumber(CANTIDAD).toFixed(3);
      }
    });

    let filaDatosAlmacen = {};
    almacenes.forEach(({ ALMACEN, CANTIDAD }) => {
      filaDatosAlmacen[ALMACEN] = this.convertToNumber(CANTIDAD).toFixed(3);
    });
    // Agrega el total descargado a la fila de datos
    const totalDescargado = Object.values(filaDatos).reduce((acc, num) => acc + parseFloat(num), 0);
    const totalDescargadoAlmacen = Object.values(filaDatosAlmacen).reduce((acc, num) => acc + parseFloat(num), 0);

    return {
      ...producto,
      bodegasUnicas,
      almacenUnicas,
      encabezados,
      encabezatres,
      items: [filaDatos],
      itemss: [filaDatosAlmacen],
      totalDescargado: totalDescargado.toFixed(3),
      totalDescargadoAlmacen: totalDescargadoAlmacen.toFixed(3)
    };
  });
},

      productosUnicos() {
      const productos = this.listaDatos.map(item => {
        const productoEncontrado = this.listaDatosProducto.find(producto => producto.ID === item.PRODUCTO);
        return {
          ID: item.ID,
          PRODUCTO: productoEncontrado ? productoEncontrado.PRODUCTO : 'Producto no encontrado',
        };
      });
      return Array.from(new Map(productos.map(producto => [producto.ID, producto])).values());
    },
     },
     methods: {

      inicializarJornadasSeleccionadas() {
  // Asumiendo que 'datosFinalesPorProducto' es donde se almacenan las jornadas por producto
  this.productosConEncabezados.forEach(producto => {
    const jornadasDisponibles = this.datosFinalesPorProducto[producto.ID].map(jornada => jornada.jornada);
    this.$set(this.jornadasSeleccionadas, producto.ID, jornadasDisponibles);
  });
},

      calculateTotalFilteredPesoBodegas(producto) {
    return producto.bodegasUnicas.reduce((total, bodega) => {
      const peso = parseFloat(this.calculateFilteredBodegaPeso(producto, bodega).replace(' TM', ''));
      return total + peso;
    }, 0);
  },

  calculateTotalFilteredPesoAlmacenes(producto) {
    return producto.almacenUnicas.reduce((total, almacen) => {
      const peso = parseFloat(this.calculateFilteredAlmacenPeso(producto, almacen).replace(' TM', ''));
      return total + peso;
    }, 0);
  },

  // Calcula el saldo restando los totales descargados de los totales filtrados
  calculateTotalSaldoBodegas(producto) {
    const totalPesoDescargadoBodegas = parseFloat(producto.totalDescargado || 0);
    const totalPesoFiltradoBodegas = this.calculateTotalFilteredPesoBodegas(producto);
    const saldo =totalPesoFiltradoBodegas - totalPesoDescargadoBodegas;
    console.log('Saldo Bodegas:', saldo); // Esto mostrará el saldo en la consola
    return saldo;
  },
  calculateTotalSaldoAlmacenes(producto) {
    const totalPesoDescargadoAlmacenes = parseFloat(producto.totalDescargadoAlmacen || 0);
    const totalPesoFiltradoAlmacenes = this.calculateTotalFilteredPesoAlmacenes(producto);
    const saldo = totalPesoFiltradoAlmacenes - totalPesoDescargadoAlmacenes;
    console.log('Saldo Almacenes:', saldo); // Esto mostrará el saldo en la consola
    return saldo;
  },


      calculateFilteredBodegaSaldo(producto, bodega) {
    const pesoInicial = producto.items[0][bodega] || 0;
    const pesoFiltrado = parseFloat(this.calculateFilteredBodegaPeso(producto, bodega).replace(' TM', ''));
    return (pesoFiltrado - pesoInicial).toFixed(3);
  },

  calculateFilteredAlmacenSaldo(producto, almacen) {
    const pesoInicial = producto.itemss[0][almacen] || 0;
    const pesoFiltrado = parseFloat(this.calculateFilteredAlmacenPeso(producto, almacen).replace(' TM', ''));
    return (pesoFiltrado - pesoInicial ).toFixed(3);
  },

      calculateFilteredBodegaPeso(producto, bodega) {
    const jornadas = this.jornadasSeleccionadas[producto.ID] || [];  // Asegura que es un array
    const jornadasFiltradas = this.datosFinalesPorProducto[producto.ID].filter(j =>
      jornadas.includes(j.jornada) || jornadas.length === 0
    );

    return jornadasFiltradas.reduce((acc, jornada) => {
      const bodegaData = jornada.bodegas.find(b => b.bodega === bodega);
      return bodegaData ? acc + parseFloat(bodegaData.pesoNeto) : acc;
    }, 0).toFixed(3) + ' TM';
  },

  calculateTotalFilteredPeso(producto) {
    return producto.bodegasUnicas.reduce((total, bodega) => {
      const peso = parseFloat(this.calculateFilteredBodegaPeso(producto, bodega).replace(' TM', ''));
      return total + peso;
    }, 0).toFixed(3) + ' TM';
  },

  calculateFilteredBodegaViajes(producto, bodega) {
    const jornadas = this.jornadasSeleccionadas[producto.ID] || [];
    const jornadasFiltradas = this.datosFinalesPorProducto[producto.ID].filter(j =>
      jornadas.includes(j.jornada) || jornadas.length === 0
    );

    return jornadasFiltradas.reduce((acc, jornada) => {
      const bodegaData = jornada.bodegas.find(b => b.bodega === bodega);
      return bodegaData ? acc + parseInt(bodegaData.viajes, 10) : acc;
    }, 0);
  },

  calculateTotalFilteredViajes(producto) {
    return producto.bodegasUnicas.reduce((total, bodega) => {
      const viajes = parseInt(this.calculateFilteredBodegaViajes(producto, bodega));
      return total + viajes;
    }, 0);
  },

  calculateFilteredPercentageDescargado(producto) {
    const totalPesoFiltrado = parseFloat(this.calculateTotalFilteredPeso(producto).replace(' TM', ''));
    // Asume que `producto.totalDescargado` ya es el total de peso que se espera descargar para este producto
    // Si `totalDescargado` también necesita ser filtrado o ajustado basado en jornadas, eso necesitaría ser calculado de forma similar a `totalPesoFiltrado`
    if (producto.totalDescargado === 0) {
      return "0.00%";
    }
    return ((totalPesoFiltrado / producto.totalDescargado) * 100).toFixed(2) + '%';
  },

  calculateFilteredAlmacenPeso(producto, almacen) {
    const jornadasFiltradas = this.datosFinalesPorProducto[producto.ID].filter(j =>
      this.jornadasSeleccionadas[producto.ID].includes(j.jornada) ||
      this.jornadasSeleccionadas[producto.ID].length === 0
    );

    return jornadasFiltradas.reduce((acc, jornada) => {
      const almacenData = jornada.almacenes.find(a => a.almacen === almacen);
      return almacenData ? acc + parseFloat(almacenData.pesoNetoAlmacen) : acc;
    }, 0).toFixed(3) + ' TM';
  },

  calculateFilteredAlmacenViajes(producto, almacen) {
    const jornadasFiltradas = this.datosFinalesPorProducto[producto.ID].filter(j =>
      this.jornadasSeleccionadas[producto.ID].includes(j.jornada) ||
      this.jornadasSeleccionadas[producto.ID].length === 0
    );

    return jornadasFiltradas.reduce((acc, jornada) => {
      const almacenData = jornada.almacenes.find(a => a.almacen === almacen);
      return almacenData ? acc + parseInt(almacenData.viajes, 10) : acc;
    }, 0);
  },

  calculateTotalFilteredAlmacenPeso(producto) {
    return producto.almacenUnicas.reduce((total, almacen) => {
      const peso = parseFloat(this.calculateFilteredAlmacenPeso(producto, almacen).replace(' TM', ''));
      return total + peso;
    }, 0).toFixed(3) + ' TM';
  },

  calculateTotalFilteredAlmacenViajes(producto) {
    return producto.almacenUnicas.reduce((total, almacen) => {
      const viajes = parseInt(this.calculateFilteredAlmacenViajes(producto, almacen));
      return total + viajes;
    }, 0);
  },

      convertir(item) {
            let numero;

            if (typeof(item) === "string") {
              numero = parseFloat(item.replace(",", "."));
            } else if (typeof(item) === "number") {
              numero = item;
            }

            // Asegura que el resultado sea un string con dos decimales
            return numero.toFixed(2);
          },

      calcularFechasYRangos(fechaInicio, indiceJornada) {
    const partes = fechaInicio.split(/[\s/:]/);
    const dia = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1; // JavaScript cuenta los meses desde 0
    const año = parseInt(partes[2], 10);
    const hora = parseInt(partes[3], 10);

    let fechaBase = new Date(año, mes, dia, hora);
    let fechaCalculada = new Date(fechaBase.getTime());

    // Determinar el rango inicial basado en la hora
    let rangoInicial;
    if (hora >= 7 && hora < 15) {
      rangoInicial = 0; // 07/15
    } else if (hora >= 15 && hora < 23) {
      rangoInicial = 1; // 15/23
    } else {
      rangoInicial = 2; // 23/07
    }

    let rangoIndex = (rangoInicial + indiceJornada) % 3;
    let diasAdicionales = Math.floor((rangoInicial + indiceJornada) / 3);

    // Ajustar la fecha para los rangos
    if (rangoIndex === 2) {
      // Para el rango de noche que empieza el día siguiente
      fechaCalculada.setDate(fechaBase.getDate() + diasAdicionales + 1);
    } else {
      fechaCalculada.setDate(fechaBase.getDate() + diasAdicionales);
    }

    let rango;
    switch (rangoIndex) {
      case 0:
        rango = "07/15";
        fechaCalculada.setHours(7, 0, 0);
        break;
      case 1:
        rango = "15/23";
        fechaCalculada.setHours(15, 0, 0);
        break;
      case 2:
        rango = "23/07";
        fechaCalculada.setHours(23, 0, 0);
        break;
    }

    const mesNombre = fechaCalculada.toLocaleString('es', { month: 'long' });
    const añoDosDigitos = fechaCalculada.getFullYear().toString().slice(-2);
    const diaFormateado = fechaCalculada.getDate().toString().padStart(2, '0');
    const fechaFormateada = `${diaFormateado} ${mesNombre} ${añoDosDigitos}`;

    return {
      fecha: fechaFormateada,
      rango: rango
    };
  },
              getPesoNetoAlmacen(jornadas, almacen) {
            const almacenData = jornadas.almacenes.find(a => a.almacen === almacen);
            return almacenData ? almacenData.pesoNetoAlmacen + ' TM' : 'N/A';
          },
          
          getViajesAlmacen(jornadas, almacen) {
            const almacenData = jornadas.almacenes.find(a => a.almacen === almacen);
            return almacenData ? almacenData.viajes : 'N/A';
          },

          captureTableAsImage(tableId) {
  // Suponiendo que BuquesFechas y BUQUE_DE_DESCARGA están disponibles
  const buqueNombre = this.BuquesFechas && this.BuquesFechas[0] ? this.BuquesFechas[0].BUQUE_DE_DESCARGA : 'Desconocido';
  const ProductoSSS = this.productosConEncabezados && this.productosConEncabezados[0] ? this.productosConEncabezados[0].PRODUCTO : 'Desconocido';
  
  // Asegurarte de seleccionar el elemento correcto basado en el ID único
  const element = this.$el.querySelector(`#${tableId}`); // Selecciona el elemento que deseas convertir

  html2canvas(element, {
    scale: window.devicePixelRatio, // Usa el ratio de píxeles del dispositivo para la escala
    useCORS: true, // Añade esta opción si estás cargando imágenes de origen cruzado
    logging: true, // Habilita el logging para depurar si es necesario
    letterRendering: 1,
    allowTaint: false // Puede ser necesario según tus necesidades de seguridad y origen de imágenes
  }).then(canvas => {
    const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
    
    // Crear un enlace para descargar la imagen
    let link = document.createElement('a');
    link.download = `Reporte_A&G.png`; // Usa el nombre del buque en el nombre del archivo
    link.href = image;
    link.click();
  }).catch(err => {
    console.error('Error al capturar la tabla:', err);
  });
},

    
      calculateTotalPesoGeneral(jornadas) {
    return jornadas.reduce((total, jornada) => total + parseFloat(this.calculateTotalPeso(jornada.bodegas)), 0).toFixed(3) + ' TM';
  },

    convertToNumber(text) {
    if (typeof text === 'number') return text; // Si ya es número, lo devuelve directamente
    return parseFloat(text.replace(',', '.'));
  },

  calculateTotalPeso(bodegas) {
    return bodegas.reduce((total, bodega) => total + this.convertToNumber(bodega.pesoNeto), 0).toFixed(3);  // Convierte y suma todos los pesos netos
  },
  
  calculateTotalPesoAlmacen(almacenes) {
    return almacenes.reduce((total, almacen) => total + this.convertToNumber(almacen.pesoNetoAlmacen), 0).toFixed(3);  // Convierte y suma todos los pesos netos
  },
  
  calculateTotalViajes(bodegas) {
    let foundSilos = false; // Bandera para detectar la presencia de "SILOS"
    
    // Suma solo los valores numéricos y detecta si hay algún "SILOS"
    const totalViajes = bodegas.reduce((total, bodega) => {
        if (bodega.viajes === "SILOS") {
            foundSilos = true; // Marca que se encontró "SILOS"
            return total;
        }
        return typeof bodega.viajes === 'number' ? total + bodega.viajes : total;
    }, 0);
    
    // Retorna "SILOS" si se encontró en alguna bodega, de lo contrario el total calculado
    return foundSilos ? "SILOS" : totalViajes;
},

  calculateTotalViajesAlmacen(almacenes) {
    return almacenes.reduce((total, almacen) => total + almacen.viajes, 0);  // Suma todos los viajes
  },

  calculatePercentageDescargado(bodegas, totalDescargado) {
  const totalPesoJornada = this.calculateTotalPeso(bodegas);
  return ((totalPesoJornada / totalDescargado) * 100).toFixed(2);
},

calculateTotalPercentageDescargado(totalPesoNeto, totalDescargado) {
    return ((totalPesoNeto / totalDescargado) * 100).toFixed(2);
  },

  totalDescargadoMaximo(bodegas) {
    // Aquí necesitas una lógica para determinar el total máximo posible de peso que se podría haber descargado
    // Esto depende de cómo defines "total máximo" en tu contexto específico
    // Asumiendo un ejemplo donde el máximo posible es la suma de los máximos estimados por bodega
    return bodegas.reduce((maxTotal, bodega) => maxTotal + (bodega.capacidadMaxima || 100), 0);  // Ejemplo: cada bodega podría tener una capacidad máxima, o usar 100 como fallback
  },

      totalDescargado(jornadas) {
    return jornadas.reduce((total, { bodegas }) => {
      return total + bodegas.reduce((subTotal, { pesoNeto }) => subTotal + parseFloat(pesoNeto), 0);
    }, 0).toFixed(3);  // Total de todos los pesos netos sumados y convertidos a string con tres decimales
  },

  porcentajeDescargado(jornadas, totalDescargado) {
    const totalMaximo = this.totalDescargadoMaximo(jornadas); // Esta función debe calcular el total máximo posible para la comparación
    return ((totalDescargado / totalMaximo) * 100).toFixed(2) + '%';  // Calcula el porcentaje
  },


  
      async fetchData() {
  this.loading = true;
  try {
    const data = await myApiCall(); // Tu llamada a la API o fuente de datos
    this.myData = data; // Asegúrate de que myData es una propiedad reactiva definida en data()
    this.loading = false;
  } catch (error) {
    console.error("Error al cargar los datos:", error);
    this.loading = false;
  }
},


         
         }
  }
</script>
<style>

.el-input, .el-select {
  width: 100%; /* Asegura que ocupen todo el ancho de su contenedor */
}

/* Estilos adicionales para ajustar el tamaño de los elementos internos de el-select y el-input */
.el-input .el-input__inner, .el-select .el-input__inner {
  height: 40px; /* O el tamaño deseado */
  line-height: 40px; /* Ajusta esto según la altura para centrar el texto verticalmente */
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Para Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.text-truncate {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-tooltip .el-tooltip__popper.is-dark {
  max-width: 200px; /* Ajusta según la necesidad */
  white-space: pre-wrap;
}


.custom-progress-bar.orange {
  background-color: #FF6800;
}

.custom-progress-bar.yellow {
  background-color: #FFAF1D;
}

.custom-progress-bar.green {
  background-color: #38c172;
}

</style>
